__turbopack_context__.v({
  "checkbox": "MultiSelect-module__8J12Oa__checkbox",
  "count": "MultiSelect-module__8J12Oa__count",
  "heading": "MultiSelect-module__8J12Oa__heading",
  "hideScrollbar": "MultiSelect-module__8J12Oa__hideScrollbar",
  "labelWrapper": "MultiSelect-module__8J12Oa__labelWrapper",
  "listbox": "MultiSelect-module__8J12Oa__listbox",
  "listboxWithApplyButton": "MultiSelect-module__8J12Oa__listboxWithApplyButton",
});
